import React from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";
import AddIcon from "@material-ui/icons/Add";
import { CircularProgress } from "@material-ui/core";

const StyledPrimaryButton = styled(Button)`
  &.MuiButton-root {
    background: #0765ff;
    color: #fff;
    font-size: 13px;
    line-height: 18px;
    border-radius: 4px;
    height: 36px;
    font-weight: 800;
    text-transform: capitalize;
    &:hover {
      background: #3a6388;
    }
  }
`;

const StyledDisabledButton = styled(Button)`
  &.MuiButton-root {
    background: #d1d1d1;
    color: #7f7f7f;
    font-size: 13px;
    line-height: 18px;
    border-radius: 4px;
    height: 36px;
    font-weight: 800;
    text-transform: capitalize;
    &:hover {
      background: #d1d1d1;
    }
  }
`;

const PrimaryButton = ({
  children,
  hideIcon,
  disabled,
  hasIcon,
  icon,
  hasCustomLabel,
  apiLoader,
  ...rest
}) => {
  return (
    <>
      {disabled ? (
        <StyledDisabledButton
          startIcon={
            hideIcon === true ? (
              <></>
            ) : hasIcon ? (
              icon
            ) : (
              <AddIcon style={{ color: "#8d8d8d" }} />
            )
          }
          disabled={disabled}
          {...rest}
        >
          {apiLoader && (
            <CircularProgress
              color="#16191f"
              size={14}
              style={{ marginRight: 4 }}
            />
          )}
          {hasCustomLabel ? children : disabled ? "Please Wait" : children}
        </StyledDisabledButton>
      ) : (
        <StyledPrimaryButton
          startIcon={
            hideIcon === true ? (
              <></>
            ) : hasIcon ? (
              icon
            ) : (
              <AddIcon style={{ color: "#fff" }} />
            )
          }
          disabled={disabled}
          {...rest}
        >
          {apiLoader && (
            <CircularProgress
              color="#16191f"
              size={14}
              style={{ marginRight: 4 }}
            />
          )}
          {hasCustomLabel ? children : disabled ? "Please Wait" : children}
        </StyledPrimaryButton>
      )}
    </>
  );
};

export default React.memo(PrimaryButton);
